import { EditTable } from 'slate-editable-table';
import { Block, Text } from 'slate';

const type = 'table';

/* To change the style of the table, use the options
defined in:
node_modules/slate-editable-table/lib/option.d.ts */

const tableOptions = {
  typeCell: 'table_cell',
  typeRow: 'table_row',
  typeTable: 'table',
  tableStyle: { width: '100%' },
  rowStyle: {},
  cellStyle: {
    backgroundColor: 'white',
    border: '1px solid black',
    padding: '10px',
    marginLeft: '10px',
  },
};

const tablePlugin = EditTable(tableOptions);

const active = () => {
  return false;
  /* tablePlugin.queries.isSelectionInTable(value); */
};

// Original code can be found here:
// https://github.com/bokuweb/slate-editable-table/blob/master/src/create-table.ts
const createCell = (opts, text, data) => {
  const { typeCell } = opts;

  return Block.fromJSON({
    type: typeCell,
    object: 'block',
    nodes: [
      {
        object: 'block',
        type: 'paragraph',
        nodes: [Text.create(text).toJSON()],
      },
    ],
    data: {
      width: opts.defaultColumnWidth,
      ...data,
    },
  });
};

const createRow = (opts, columns, columnWidth) => {
  let cellNodes = [];

  for (let i = 0; i < columns; i += 1) {
    cellNodes.push(createCell(opts, '', { width: `${columnWidth}` }).toJSON());
  }
  cellNodes = Array.from(cellNodes);

  return Block.fromJSON({
    object: 'block',
    type: opts.typeRow,
    nodes: cellNodes,
    data: {},
  });
};

const createTable = (opts, columns, rows, tabOptions) => {
  let rowNodes = [];

  for (let i = 0; i < rows; i += 1) {
    rowNodes.push(
      createRow(opts, columns, tabOptions && tabOptions.columnWidth).toJSON(),
    );
  }
  rowNodes = Array.from(rowNodes);

  return Block.fromJSON({
    object: 'block',
    type: opts.typeTable,
    nodes: rowNodes,
    data: {
      maxWidth: tabOptions && tabOptions.maxWidth,
    },
  });
};

export function Table() {
  return {
    button: {
      elementType: type,
      type,
      active,
      handleClick: store => {
        const { reference, onChange } = store;
        onChange(reference);
      },
      icon: 'edit',
    },
    plugins: [
      props => {
        tablePlugin.renderNode(props, props.editor);
      },
      tablePlugin,
    ],
  };
}

export { tableOptions, createTable };
